(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('file-store', {
                parent: 'entity',
                url: '/file-store?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'moldovaYieldCurvesApp.fileStore.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/file-store/file-stores.html',
                        controller: 'FileStoreController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fileStore');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('file-store-detail', {
                parent: 'file-store',
                url: '/file-store/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'moldovaYieldCurvesApp.fileStore.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/file-store/file-store-detail.html',
                        controller: 'FileStoreDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fileStore');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'FileStore', function ($stateParams, FileStore) {
                        return FileStore.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'file-store',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('file-store-detail.edit', {
                parent: 'file-store-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/file-store/file-store-dialog.html',
                        controller: 'FileStoreDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['FileStore', function (FileStore) {
                                return FileStore.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('file-store.new', {
                parent: 'file-store',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/file-store/file-store-dialog.html',
                        controller: 'FileStoreDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    fileId: null,
                                    dataBlob: null,
                                    validated: false,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('file-store', null, {reload: 'file-store'});
                    }, function () {
                        $state.go('file-store');
                    });
                }]
            })
            .state('file-store.edit', {
                parent: 'file-store',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/file-store/file-store-dialog.html',
                        controller: 'FileStoreDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['FileStore', function (FileStore) {
                                return FileStore.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('file-store', null, {reload: 'file-store'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('file-store.delete', {
                parent: 'file-store',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/file-store/file-store-delete-dialog.html',
                        controller: 'FileStoreDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['FileStore', function (FileStore) {
                                return FileStore.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('file-store', null, {reload: 'file-store'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
